import { getConfig } from "@cirrus/config"
import { getLink } from "./getLink"

//TODO: Need to refactore delivery external login to handle the same way
export function toAfterExternalLogin(result) {
  const { access_token } = result
  const authorConfig = getConfig("author")

  sessionStorage.setItem(authorConfig.TokenKey, access_token)
  window.location.href = getLink(result)
}
